import { fromJS } from 'immutable';
import debug from 'utils/debug';
import { STOPS_FETCH_SUCCESS, DRIVERS_FETCH_SUCCESS } from './actions';

const D2 = debug('m:entities:index');

export const initialState = fromJS({
  stops: null,
  drivers: null,
});

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case STOPS_FETCH_SUCCESS: {
      D2.S.REDUX_EVENT_HANDLER(type, payload);

      const { stops, stopsByType } = payload;

      return state.set('stopsByType', stopsByType).set(
        'stops',
        stops.features.reduce((acc, item) => {
          const { code } = item.properties;
          acc[code] = item;
          return acc;
        }, {})
      );
    }
    case DRIVERS_FETCH_SUCCESS: {
      D2.S.REDUX_EVENT_HANDLER(type, payload);

      const { drivers } = payload;

      return state.set('drivers', drivers);
    }
    default:
      return state;
  }
};

export default reducer;
